//Aquí voy a implementar mi dashboard
import { useSelector } from 'react-redux'
import Tarjetas from './components-dashboard/Tarjetas.js'
import Layout from './Layout.js'
import Container from './components-layout/Container.js'
import IngresosPorPlan from './components-dashboard/IngresosPorPlan.js'
import IngresosPorCargo from './components-dashboard/IngresosPorCargo.js'
import IngresosPorSede from './components-dashboard/IngresosPorSede.js'
import EfectivoSinCuadrar from './components-dashboard/EfectivoSinCuadrar.js'
import EdoCuenta from './components-dashboard/EdoCuenta.js'
import { useEffect, useState } from 'react'
import Axios from 'axios'
import WarningModal from './components-modals/WarningModal.js'
import Button from './components-login/Button.js'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
const dirWebApp = process.env.REACT_APP_DIR_PRO

const Dashboard = () => {

  const urlSchoolApi = useSelector((state) => state.url.urlSchoolApi)
  const headersApi = useSelector((state) => state.url.headersAPI)

  const status = useSelector((state) => state.url.ApiResponse)

  const urlDashboard = urlSchoolApi + '/finanzas/contadashboard'

  const user = useSelector(state => state.auth.user)
  const IdEmp = useSelector(state => state.auth.IdEmp)
  const userObj = JSON.parse(user)

  const FFin = new Date()
  const arrFFin = FFin.toLocaleDateString('es-ES').split('/').reverse()
  const FIni = new Date(Number(arrFFin[0]), Number(arrFFin[1]) - 1, 1)
  
  const today = new Date().toLocaleDateString('es-GT', { day: 'numeric', month: 'long', year: 'numeric', })
  
  const [infoDisclaimer, setInfoDisclaimer] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      try{
        const response = await Axios({
          method: 'GET',
          url: urlSchoolApi + '/finanzas/exportarisc',
          headers: headersApi,
          params: {
            "Opcion": "5",
            "IdEmp": IdEmp,
          }
        })
        setInfoDisclaimer(response.data)
      }catch(err){
        console.log(err)
      }
    }
    fetchData()
  }, [urlSchoolApi])

  const [loadingAPIS, setLoadingAPIS] = useState({
    tarjetas: false,
    IngresosPorPlan: false,
    IngresosPorCargo: false,
    EfectivoSinCuadrar: false,
    IngresosPorSede: false,
    EdoCuenta: false,
  })

  const loading = Object.values(loadingAPIS).some(x => x === false) 

  if (status === 'succeed') {
    return (
      <Layout userObj={userObj} activeTab='Dashboard'>
            {
              infoDisclaimer.length > 1 ?
                <WarningModal
                        open={infoDisclaimer.length > 1 && !loading ? true : false}
                        image={
                            <CheckCircleIcon
                                className="h-14 w-14 text-secundario mx-auto"
                            />
                        }
                        width='w-auto'
                        title={
                        <p className='pb-2'>
                          {infoDisclaimer[0]?.Mensaje}
                        </p>
                      }
                        subtitle={
                          <>
                            <ul className='pl-5 list-disc'>
                              {
                                infoDisclaimer?.slice(1, -2).map((x, idx) => {
                                  return(
                                    <li
                                      className='text-left py-1 px-2 font-semibold' 
                                      key={idx}
                                    >
                                      {x.Descripcion + ' - ' + x.Empresa}
                                    </li>
                                  )
                                })
                              }
                            </ul>
                            <div className='pt-5'>
                              <p className='text-yellow-500 font-semibold'>
                                {infoDisclaimer?.slice(-2)[0].Mensaje}
                                <br/>
                                <span className='font-bold text-red-500'>
                                  {infoDisclaimer?.slice(-2)[1].Mensaje}  
                                </span>
                              </p>
                            </div>
                          </>
                        }
                        opacity='bg-opacity-50'
                >
                        <div className="mt-5 sm:mt-6">
                            <Button
                                onClick={() => {
                                  setInfoDisclaimer(false)
                                }}
                                type="button"
                                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                            >
                                Entendido
                            </Button>
                        </div>
                </WarningModal>
              : null
            }
            {
            loading ? 
              <WarningModal
                  open={loading ? true : false}
                  image={<img src='./img/loader.gif' alt='loading' />}
                  opacity='bg-opacity-100'
              />
            : null
            }
            <Container height='h-full'>
              <div className='mb-5 pt-0 flex justify-between border border-secundarioMira border-b-grisMira flex-wrap gap-5'>
                <div className='mt-5 lg:mb-11'>
                  <h1 className='text-2xl font-semibold text-white'>
                    Dashboard Finanzas
                  </h1>
                </div>
                <div className='mb-5 lg:mb-11 lg:mt-5 bg-azulBrillanteMira py-1 px-3 rounded-lg flex place-content-center'>
                  <p className='my-auto text-white text-sm font-semibold'>
                    Fecha: {today}
                  </p>
                </div>
              </div>
              <div className='h-full flex flex-col flex-wrap xl:grid xl:grid-cols-3 gap-5'>
                <div className='col-start-1 col-end-1 bg-primarioMira rounded-lg'>
                  <Tarjetas
                    FIni={FIni.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join('')}
                    FFin={FFin.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join('')}
                    url={urlDashboard}
                    headers={headersApi}
                    setLoadingAPIS={setLoadingAPIS}
                  />
                </div>
                <div className='col-start-2 col-end-4 rounded-lg h-auto bg-primarioMira'>
                  <IngresosPorPlan
                    FFin={FFin.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join('')}
                    url={urlDashboard}
                    headers={headersApi}
                    setLoadingAPIS={setLoadingAPIS}
                  />
                </div>
                <div className='row-start-2 col-start-3 col-end-4 rounded-lg bg-primarioMira'>
                  <IngresosPorCargo
                    FIni={FIni.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join('')}
                    FFin={FFin.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join('')}
                    url={urlDashboard}
                    headers={headersApi}
                    setLoadingAPIS={setLoadingAPIS}
                  />
                </div>
                <div className='row-start-2 col-start-1 col-end-3 h-auto'>
                  <EfectivoSinCuadrar
                    url={urlDashboard}
                    headers={headersApi}
                    setLoadingAPIS={setLoadingAPIS}
                  />
                </div>
                <div className='col-start-1 col-end-2 h-auto bg-primarioMira rounded-lg px-4'>
                  <IngresosPorSede
                    FFin={FFin.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join('')}
                    url={urlDashboard}
                    headers={headersApi}
                    setLoadingAPIS={setLoadingAPIS}
                  />
                </div>
                <div className='col-start-2 col-end-4 w-full bg-primarioMira h-full rounded-lg py-2 lg:py-0 px-4 lg:px-0'>
                  <EdoCuenta
                    url={urlDashboard}
                    headers={headersApi}
                    setLoadingAPIS={setLoadingAPIS}
                  />
                </div>
              </div>
            </Container>
      </Layout>
    )
  }
}

export default Dashboard